import Card from '../card/Card';
import TitleH1 from '../common/TitleH1';
import { BlockColumnHeight, CardInfo, PushCardBackground } from '../types';

interface Props {
  cards: Array<CardInfo>;
  height: BlockColumnHeight;
  title?: string;
  background?: PushCardBackground;
  isHome?: boolean;
}

export default function CardPushBlock({ cards, title, height = 'default', isHome=false }: Props) {
  let imageSizes = '100vw';
  let backgroundEllipse = 'md:bg-card-small-push-no-image-right-ellipse';

  if (cards.length === 2) {
    imageSizes = '(min-width: 66em) 35vw, (min-width: 44em) 50vw, 100vw';
    backgroundEllipse = 'md:bg-card-small-push-no-image-right-ellipse-mobile-3-columns';
  } else if (cards.length === 3) {
    imageSizes = '(min-width: 66em) 30vw, (min-width: 44em) 33.33vw, 100vw';
    backgroundEllipse = 'md:bg-card-small-push-no-image-right-ellipse-mobile-3-columns';
  }
  let divHeight = 'lg:h-[250px]';
  let cardMobileImageHeight = 'h-[270px]';
  switch (height) {
    case 'medium':
      divHeight = 'lg:h-[400px]';
      cardMobileImageHeight = 'lg:h-[400px] h-[350px]';
      break;
    case 'high':
      divHeight = 'lg:h-[571px] h-auto';
      cardMobileImageHeight = 'lg:h-[571px] h-[480px]';
      break;
  }

  const animated = isHome && cards.length === 3;

  return (
    <div className={`${animated && 'md:mt-4'}`}>
      {title && (
        <div className="py-8">
          <TitleH1 styles="grow" color="black" size="medium">
            {title}
          </TitleH1>
        </div>
      )}

      <div className={`flex lg:block_second ${divHeight} flex-col gap-3 lg:flex-row`}>
        {cards.map(
          (
            {
              background,
              button,
              image,
              intro,
              title,
              imageAlt,
              callToActionUrl,
              description,
              socials_items,
            },
            index,
          ) => (
            <Card
              key={index}
              title={title}
              intro={intro}
              type={Array.isArray(socials_items) && socials_items.length > 0 ? 'social' : 'push'}
              description={description}
              callToActionUrl={callToActionUrl}
              image={image}
              imageAlt={imageAlt}
              imageSizes={imageSizes}
              stylesImage={cardMobileImageHeight}
              button={button}
              background={background}
              backgroundEllipse={backgroundEllipse}
              socials_items={socials_items}
              columnCount={cards.length}
              animated={animated}
            ></Card>
          ),
        )}
      </div>
    </div>
  );
}
